<script>

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useMethodStore } from '@/store/methodStore'
import socket from '@/services/socket';

import { ref } from "vue";


import { useCurrencyStore } from '@/store/currencyStore'
import { useCountryStore } from '@/store/countryStore'
import Swal from "sweetalert2";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false)
      
        const methodStore = useMethodStore();
        const currencyStore = useCurrencyStore();
        const countryStore = useCountryStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          methodStore,
         currencyStore,
         countryStore,

        };
    },
    page: {
    title: "Pays",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Pays",
      items: [
        {
          text: "Menu",
        },
        {
          text: "Pays",
          active: true,
        },
      ],
      errors: [],
      method: {},
      countries: [],
      currencies: [],
      methods: [],
      methods_search: [],
      name: "",
      langs: "",
      carrier: "",
      logo: "",
      label_fr: "",
      label_ru: "",
      label_en: "",
      label_pt: "",
      description_en: "",
      description_fr: "",
      description_ru: "",
      description_pt: "",
      country_id: "",
      currency_id: "",
      type: "",
      loading: false,
      method_status: true,
      search: '',
      status: 201,
      length: 0,
    };
  },


  methods: { 

    async loadFromStore() {

        if (!this.methodStore.methods) {
        await  this.methodStore.loadFromApi(true).then(data => {
          this.methods = data
          this.method_search = data;
          this.length = this.method.length;
        })
        } else {
          this.methods = this.methodStore.list
          this.method_search = this.methods;
                    this.length = this.method.length;
        }

        // Écoute temps réel
        socket.on('method.created', (data) => {
          this.methodStore.addOne(data)
          this.methods = this.methodStore.list
          this.method_search = this.methodStore.list;
                    this.length = this.method.length;

        });

        socket.on('method.updated', (data) => {
          this.methodStore.updateOne(data)
          this.methods = this.methodStore.list
          this.method_search = this.methodStore.list;
                    this.length = this.method.length;

        });

    },

    addItem() {
      this.errors = [];
        let body = {
          status: this.method_status,
          name: this.name,
        langs: this.langs,
        logo: this.logo,
        label_fr: this.label_fr,
        label_en: this.label_en,
        label_ru: this.label_ru,
        label_pt: this.label_pt,
        
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
          description_pt: this.description_pt,
         
        country: {
          id: this.country_id
        },
        currency: {
          id: this.currency_id
        }
      }

      

      if (this.carrier !== '') {
        body['carrier'] = this.carrier
      }

      if (this.type !== "") {
        body['type'] =  this.type
      }


      Object.keys(body).forEach(key => {
        if (body[key] === '' || body[key] == null) {
          delete body[key]
        }
      })

      this.methodStore.createItem(body);
      this.methods = this.methodStore.list
      this.method_search = this.methods

    },

    editItem() {
      this.errors = [];
      let body = {
        status: this.method_status,
        name: this.name,
        langs: this.langs,
        logo: this.logo,
        label_fr: this.label_fr,
        label_en: this.label_en,
        label_ru: this.label_ru,
        label_pt: this.label_pt,
        carrier: this.carrier,
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
        description_pt: this.description_pt,
        country: {
          id: this.country_id
        },
        currency: {
          id: this.currency_id
        }
      }

      Object.keys(body).forEach(key => {
        if (body[key] === ''  || body[key] == null) {
          delete body[key]
        }
      })

      if (this.type !== "") {
        body['type'] =  this.type
      }

      this.methodStore.editItem(this.method.id, body);
      this.methods = this.methodStore.list
      this.method_search = this.methods

      
    },

    deleteIt() {
      this.methodStore.deleteItem(this.method.id);
      this.methods = this.methodStore.list
      this.method_search = this.methods
    },

   async refresh(){
     await  this.methodStore.loadFromApi(true).then(data => {
          this.methods = data
          this.method_search = data;
          this.length = this.method.length;
        })
   },

     compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },
      
    async loadCountries() {

        if (!this.countryStore.list) {
        await  this.countryStore.loadFromApi().then(data => {
          this.countries = data
        })
        } else {
          this.countries = this.countryStore.list
        }

    },
    
    async loadCurrencies() {

        if (!this.currencyStore.list) {
        await  this.currencyStore.loadFromApi().then(data => {
          this.currencies = data
      })
        } else {
          this.currencies = this.currencyStore.list
        }

    },
      
    filter_method() {    
      this.methods = this.methods_search
      if (this.search != "") {
        this.methods = this.methods.filter(user => (
          user.name?.toLowerCase().includes(this.search.toLowerCase()) || 
          user.country?.name_fr?.toLowerCase().includes(this.search.toLowerCase()) || 
          user.label_fr?.toLowerCase().includes(this.search.toLowerCase()) 
        )) 
      }
    },
      
    async  onAddItem(){

        Swal.showLoading(null);
        await Promise.all([
          this.loadCountries(),
          this.loadCurrencies()
        ]);
        Swal.close();
        this.doesAddOpen = true;
    },

    async  initItem(method, action="edit") {
      this.method = method
      this.initData(method)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
          Swal.showLoading(null);
        await Promise.all([
          this.loadCountries(),
          this.loadCurrencies()
        ]);
        Swal.close();
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.method_status = item != null ? item.status : ""
      this.name = item != null ? item.name : ""
      this.langs = item != null ? item.langs : ""
      this.logo = item != null ? item.logo : ""
      this.type = item != null ? item.type : ""
      this.label_fr = item != null ? item.label_fr : ""
      this.label_en = item != null ? item.label_en : ""
      this.label_ru = item != null ? item.label_ru : ""
      this.label_pt = item != null ? item.label_pt : ""
      this.carrier = item != null ? item.carrier : ""
      this.description_en = item != null ? item.description_en : ""
      this.description_fr = item != null ? item.description_fr : ""
      this.description_ru = item != null ? item.description_ru : ""
      this.description_pt = item != null ? item.description_pt : ""
      this.country_id = item != null ? item?.country?.id : ""
      this.currency_id = item != null ? item?.currency?.id : ""
    }

  },

  mounted() {
    this.loadFromStore()
    
    this.doesLoadingOpen = false
  },

  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.method = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.method = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="hstack mb-3" v-show="status !== 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
        <b-button variant="primary" @click="onAddItem()" class="ms-1">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <input type="search" class="form-control" v-model="search" v-on:input="filter_method()" placeholder="Rechercher">
      </div>
    </div>
    
    <div class="row" v-show="status !== 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des methods</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>methods</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr class="bg-light">
                    <th>#</th>
                    <th>Logo</th>
                    <th>Pays</th>
                    <th>Nom</th>
                    <th>Label FR</th>
                    <th>Type</th>
                    <th>Langs</th>
                    <th>Status</th>
                    <th class="ps-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(method, i) in methods"  :key="method.id">
                    <th scope="row"  v-on:click="compileToClipboard(method.id)"
                                          style="cursor: pointer">{{ i + 1 }}</th>
                    <th scope="row">
                      <img :src="method?.logo" :alt="method.name" style="height: 35px; width: 35px" class="border rounded-circle">
                    </th>
                    <td>{{ method?.country?.name_fr }}</td>
                    <td>{{ method?.name }}</td>
                    <td>{{ method.label_fr }}</td>
                    <td>{{ method.type }}</td>
                    <td>{{ method.langs }}</td>
                    <td>{{ method.status ? "Activé" : "Non activé" }}</td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(method, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(method, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <router-link :to="'/methods/' + method.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>


    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="lg"
        title="Ajouter un pays"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            <div class="col-md-6 mb-3">
                <label for="">Sélectionnez le Pays</label>
                <select required v-model="country_id" class="form-control">
                    <option value=""></option>
                    <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name_fr }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label for="">Sélectionnez la devise</label>
                <select required v-model="currency_id" class="form-control">
                    <option value=""></option>
                    <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.name_fr }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Méthode</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Status </label>
              <select class="form-control" required v-model="method_status">
                <option :value="true">Activé</option>
                <option :value="false">Desactivé</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.method_status">{{ errors.method_status }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select v-model="type" class="form-control">
                <option value="">Non définie</option>
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Carrier</label>
              <input type="text" required v-model="carrier" class="form-control">
              <span class="text-danger mt-2" v-if="errors.carrier">{{ errors.carrier }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Logo</label>
              <input type="text" required v-model="logo" class="form-control">
              <span class="text-danger mt-2" v-if="errors.logo">{{ errors.logo }}</span>
            </div>
             <div class="col-md-6 mb-3">
              <label for="">Langs </label>
              <select class="form-control" required v-model="langs">
                <option value="eng">English</option>
                <option value="fra">Français</option>
                <option value="rus">Русский Язык</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.langs">{{ errors.langs }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label FR</label>
              <input type="text" required v-model="label_fr" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_fr">{{ errors.label_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label EN</label>
              <input type="text" required v-model="label_en" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_en">{{ errors.label_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label PT</label>
              <input type="text" required v-model="label_pt" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_pt">{{ errors.label_pt }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label RU</label>
              <input type="text" required v-model="label_ru" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_ru">{{ errors.label_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="lg"
        title="Modifier un method"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            <div class="col-md-6 mb-3">
                <label for="">Sélectionnez le Pays</label>
                <select required v-model="country_id" class="form-control">
                    <option value=""></option>
                    <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name_fr }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label for="">Sélectionnez la devise</label>
                <select required v-model="currency_id" class="form-control">
                    <option value=""></option>
                    <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.name_fr }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Méthode</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Status </label>
              <select class="form-control" required v-model="method_status">
                <option :value="true">Activé</option>
                <option :value="false">Desactivé</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.method_status">{{ errors.method_status }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select v-model="type" class="form-control">
                <option value="">Non définie</option>
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Carrier</label>
              <input type="text" required v-model="carrier" class="form-control">
              <span class="text-danger mt-2" v-if="errors.carrier">{{ errors.carrier }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Logo</label>
              <input type="text" required v-model="logo" class="form-control">
              <span class="text-danger mt-2" v-if="errors.logo">{{ errors.logo }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Langs </label>
              <select class="form-control" required v-model="langs">
                <option value="eng">English</option>
                <option value="fra">Français</option>
                <option value="rus">Русский Язык</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.langs">{{ errors.langs }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label FR</label>
              <input type="text" required v-model="label_fr" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_fr">{{ errors.label_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label EN</label>
              <input type="text" required v-model="label_en" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_en">{{ errors.label_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label PT</label>
              <input type="text" required v-model="label_pt" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_pt">{{ errors.label_pt }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label RU</label>
              <input type="text" required v-model="label_ru" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_ru">{{ errors.label_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un method"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer le method <b>{{ method?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
